export const getBranding = () => {
  const hostname = window.location.hostname;
  if (hostname.includes('buddytools')) {
    return {
      theme: 'buddytools',
      logo: '/logo.png',
      toolName: 'BuddyTools',
      companyName: 'BuddyTools Inc.',
      companyLink: 'https://buddytools.com', // Example link
      colors: {
        primary: '#00a4ef',
        secondary: '#333',
        button: '#00a4ef',
      },
    };
  } else if (hostname.includes('citadelstrategicventures')) {
    return {
      theme: 'citadel',
      logo: '/logo.png',
      toolName: 'CiTools',
      companyName: 'Citadel Strategic Ventures',
      companyLink: 'https://citadelstrategicventures.com',
      colors: {
        primary: '#dd4b39',
        secondary: '#333',
        button: '#dd4b39',
      },
    };
  } else if (hostname.includes('coca-cola')) {
    return {
      theme: 'cocacola',
      logo: '/logo.png',
      toolName: 'Coca-Cola Internal Tools',
      companyName: 'The Coca-Cola Company',
      companyLink: 'https://coca-cola.com', // Example link
      colors: {
        primary: '#f40000',
        secondary: '#fff',
        button: '#f40000',
      },
    };
  } else {
    return {
      theme: 'citadel',
      logo: '/logo.png',
      toolName: 'CiTools',
      companyName: 'Citadel Strategic Ventures',
      companyLink: 'https://citadelstrategicventures.com',
      colors: {
        primary: '#dd4b39',
        secondary: '#333',
        button: '#dd4b39',
      },
    };
  }
};
